import { useLang } from "@/i18n";

const ITEMS = [
    { de: "Kabelkopfstationen DH8 / DH4 / DH2", en: "Cable headends DH8 / DH4 / DH2" },
    { de: "SAT-ZF Verteiltechnik", en: "SAT-IF distribution technology" },
    { de: "48h Grundig Kassetten-Reparatur", en: "48h Grundig cassette repair" },
    { de: "Fibre-Glas Empfangssysteme", en: "Fibre optic receive systems" },
    { de: "Antennenheizungen", en: "Antenna heating systems" },
    { de: "Multischalter & Einzelumsetzer", en: "Multi-switches & transmodulators" },
    { de: "Planung GA / GGA / BK-Netze", en: "Planning for CATV & estate networks" },
    { de: "InfoMedia-Player", en: "InfoMedia players" },
    { de: "Fachhandelskatalog — alles ab Lager", en: "Trade catalogue — everything ex stock" },
];

export default function Marquee() {
    const { t } = useLang();
    return (
        <div
            data-testid="marquee"
            className="relative border-y border-slate-200 bg-slate-100/80 py-4 overflow-hidden marquee-mask"
        >
            <div className="flex w-max animate-marquee">
                {[0, 1].map((copy) => (
                    <div key={copy} aria-hidden={copy === 1} className="flex shrink-0 items-center">
                        {ITEMS.map((it) => (
                            <span
                                key={it.de}
                                className="flex items-center font-mono text-xs sm:text-sm uppercase tracking-[0.16em] text-slate-500"
                            >
                                <span className="px-7 whitespace-nowrap">{t(it.de, it.en)}</span>
                                <span className="h-1 w-1 rounded-full bg-red-600/70" />
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}
